import { authorizeGetRequest, authorizePutRequest } from "api";
import { IApiResponse, IPaginatedResponse } from "models";
import { IBanPassenger, IUser } from "models/user";

export const passengersApi = (
  page: number,
  perPage: number,
  search: string
) => {
  if (search) search = search.replace("+", "%2B");
  return authorizeGetRequest<IPaginatedResponse<IUser>>(
    `passengers?page=${page}&per_page=${perPage}&query=${search}`
  );
};
export const fetchPassengerByIdApi = (id: string) => {
  return authorizeGetRequest<IApiResponse<IUser>>(`passengers/${id}`);
};

export const banPassengerByIdApi = (id: string, input: IBanPassenger) => {
  return authorizePutRequest<IApiResponse<IUser>>(
    `passengers/${id}/ban`,
    input
  );
};

export const activatePassengerApi = (id: string) => {
  return authorizePutRequest<IApiResponse<IUser>>(
    `passengers/${id}/activate`,
    {}
  );
};

export const updatePassengerByIdApi = (id: string, input: any) => {
  return authorizePutRequest<IApiResponse<IUser>>(
    `passengers/admin-update/${id}`,
    input
  );
};
